mutation cancelDowngrade($companyId: ID!) {
  cancelDowngrade(companyId: $companyId)
}
